import http from "../utils/axios";
// 获取管理员列表接口
export const getAdminList = data => {
  return http({
    url: "/api/admin/getAdminList", // 接口
    method: "post",
    data: data
  });
};
// 添加、编辑管理员（账户）
export const changeAdmin = data => {
  return http({
    url: "/api/admin/changeAdmin", // 接口
    method: "post",
    data: data
  });
};
// 修改账号密码接口
export const changePassword = data => {
  return http({
    url: "/api/admin/changePassword", // 接口
    method: "post",
    data: data
  });
};
// 获取指定账号信息接口
export const getAdminInfo = data => {
  return http({
    url: "/api/admin/getAdminInfo", // 接口
    method: "post",
    data: data
  });
};
// 获取岗位列表
export const getAuthList = data => {
  return http({
    url: "/api/auth/getAuthList", // 接口
    method: "post",
    data: data
  });
};
// 获取登录账号所属及其下属团队接口
export const getTeam = data => {
  return http({
    url: "/api/team/getTeam", // 接口
    method: "post",
    data: data
  });
};
// 获取登录账号所属及其下属团队接口
export const getAdmin = data => {
  return http({
    url: "/api/admin/getAdmin", // 接口
    method: "post",
    data: data
  });
};
// 获取产品佣金配置信息接口
export const getProductChannelList = data => {
  return http({
    url: "/api/Product_Channel/getProductChannelList", // 接口
    method: "post",
    data: data
  });
};
// 配置可开放产品接口
export const changeProductChannel = data => {
  return http({
    url: "/api/product_channel/changeProductChannel", // 接口
    method: "post",
    data: data
  });
};
